import axios from 'axios';
import {v4 as uuid} from 'uuid';
import moment from 'moment-timezone';
import {find, isInteger, isObject, isString} from 'lodash';
import presentationFileService from '../../../ml/services/presentationFileService';

export default {
  async openExcelFile(presentation, file) { // MLD-3040
    // @see https://docs.microsoft.com/en-us/office/client-developer/office-uri-schemes#17-implementation-restrictions-on-command-arguments
    const protocol = `ms-excel:ofv|u`
    return this.openOfficeFile(protocol, presentation, file)
  },
  async openPowerPointFile(presentation, file) {
    // @see https://docs.microsoft.com/en-us/office/client-developer/office-uri-schemes#17-implementation-restrictions-on-command-arguments
    const protocol = `ms-powerpoint:ofv|u`
    return this.openOfficeFile(protocol, presentation, file)
  },
  openOfficeFile(protocol, presentation, file) {
    const uri = `${window.config.appURL}/p/${presentation.uuid}/${file.path}`;
    const url = `${protocol}|${uri}`;
    const link = document.createElement('a');
    link.href = url;
    link.target = '_blank';
    link.dispatchEvent(new MouseEvent(`click`, {bubbles: true, cancelable: true, view: window}));
  },
  async downloadZipFilePresentation(presentation) { // MLD-5606
    const files = await presentationFileService.getFiles(presentation.id);
    const mainFile = find(files, f => f.path === presentation.main_path);
    if (mainFile) {
      const link = document.createElement('a');
      link.href = mainFile.url;
      link.download = mainFile.name;
      link.dispatchEvent(new MouseEvent(`click`, {bubbles: true, cancelable: true, view: window}));
    }
  },
  async launchPresentation(presentation, newTab, router, data) {

    // Create the session
    const {data: sessionData} = await axios.post(`/api/user/presentations/${presentation.id}/session`, data)
    await this.openPresentation(sessionData);

    if (newTab) {
      const link = document.createElement('a');
      link.href = sessionData.absolute_signed_url;
      link.target = '_blank';
      link.dispatchEvent(new MouseEvent(`click`, {bubbles: true, cancelable: true, view: window}));
    } else {
      const to = {
        name: 'library.present',
        params: {
          presentationID: presentation.id,
        },
        query: {
          session_uuid: sessionData.uuid,
        }
      }
      try {
        router.push(sessionData.relative_signed_url);
      } catch (e) {
        console.log(e.message);
      }
      //window.location.assign(signedURL);
    }
  },
  openPresentation(session) {
    const event = {
      presentation_id: session.presentation_id,
      session_id: session.uuid,
      session_started_at: moment(session.started_at).unix(),
      category: 'presentation',
      action: 'open',
      uri: 'open-presentation',
    }
    return this.logEvent(event);
  },
  closePresentation(payload) {
    const session = payload.session;
    const meta = payload.meta;
    const event = {
      presentation_id: session.presentation_id,
      session_id: session.uuid,
      session_started_at: moment(session.started_at).unix(),
      category: 'presentation',
      action: 'close',
      uri: 'close-presentation',
      session_entities: payload.session_entities ?? [], // MLD-5823
    }
    if (isObject(meta) && isInteger(meta.elapsedMS)) { // MLD-4832
      event.elapsed_ms = meta.elapsedMS;
    }
    return this.logEvent(event);
  },
  endActivity(activityID) { // MLD-2463
    return axios.put(`/api/crm/activities/${activityID}/end`)
      .then(response => response.data);
  },
  changePageMeta(session, presentation, meta, pageNumber, slide = null) {
    const event = {
      presentation_id: session.presentation_id,
      session_id: session.uuid,
      session_started_at: moment(session.started_at).unix(),
      elapsed_ms: meta.elapsedMS,
      category: 'PDF',
      action: 'change_page',
      uri: `Page ${pageNumber}`,
      data: {
        page: pageNumber,
        title: presentation.name,
        totalPages: meta.totalPages,
      }
    }
    if (isObject(slide) && isString(slide.name)) { // MLD-6435
      event.slide_id = slide.id;
    }
    return this.logEvent(event);
  },
  changePage(session, presentation, pageNumber, totalPages) {
    const event = {
      presentation_id: session.presentation_id,
      session_id: session.uuid,
      session_started_at: moment(session.started_at).unix(),
      category: 'PDF',
      action: 'change_page',
      uri: `Page ${pageNumber}`,
      data: {
        page: pageNumber,
        title: presentation.name,
        totalPages: totalPages,
      }
    }
    return this.logEvent(event);
  },
  logEvent(event) {
    const now = Date.now();
    event.id = uuid();
    event.event_at = Math.floor(now / 1000);
    event.event_at_ms = now;
    //console.log('logEvent', event.category, event.action, event);
    return axios.post(`/api/app/events`, event)
      .then(response => response.data);
  },
  getDeviceSession(sessionUUID) {
    return axios.get(`/api/app/device-sessions/${sessionUUID}`)
      .then(response => response.data);
  },
  endSession(session) {
    //console.log('endSession', session.uuid);
    return axios.put(`/api/app/device-sessions/${session.uuid}/end`);
  },
  toggleLiveMode(session, liveMode) {
    const data = {
      live_mode: liveMode,
    }
    //console.log('toogleLiveMode', session.uuid, liveMode);
    return axios.put(`/api/app/device-sessions/${session.uuid}`, data)
      .then(response => response.data)
  }
}
